import React, { useState } from 'react';
import { isMobile } from 'react-device-detect';

import FaqService from 'services/faqService';
import styled from 'styled-components';
import ButtonOutline from '../button-outline/ButtonOutline';

const ArticleFeedbackWrapper = styled.div`
    margin: 1.5rem 0 3rem;
`;

const ArticleFeedbackTitle = styled.p`
    font-weight: 700;
    margin-bottom: 1.5rem;
`;

const ArticleFeedbackMessage = styled.p`
    font-size: 0.875rem;
`;

const ArticleFeedbackActions = styled.div`
    display: grid;
    grid-gap: 1rem;
    grid-template-columns: 1fr 1fr;
    max-width: ${isMobile ? '100%' : '340px'};
    width: 100%;
`;

const ArticleFeedback = ({ articleId }) => {
    const [message, setMessage] = useState('');
    const upvote = () => {
        FaqService.articleUpvote(articleId)
            .then(({ data }) => setMessage(data.message));
    }

    const downvote = () => {
        FaqService.articleDownvote(articleId)
            .then(({ data }) => setMessage(data.message));
    }

    return (
        <ArticleFeedbackWrapper>
            <ArticleFeedbackTitle>Este artigo ajudou?</ArticleFeedbackTitle>
            {message ? (<ArticleFeedbackMessage>{message}</ArticleFeedbackMessage>) : (
                <ArticleFeedbackActions>
                    <ButtonOutline label="Sim" clickFn={upvote} />
                    <ButtonOutline label="Não" clickFn={downvote} />
                </ArticleFeedbackActions>
            )}
        </ArticleFeedbackWrapper>
    );
}

export default ArticleFeedback;